import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const DropdownMenu = ({ item, selectedRowId, setSelectedRowId, openPaymentModal }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget); // Open the menu on button click
    setSelectedRowId(selectedRowId === item.id ? null : item.id); // Toggle the selectedRowId
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <div className="relative">
      <IconButton
        aria-label="more"
        onClick={handleClick} // Open the menu when the icon is clicked
          style={{ outline: 'none', boxShadow: 'none' }}
      >
        <MoreHorizIcon style={{ color: 'gray' }} />
      </IconButton>
      <div className='absolute top-0 left-0'>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose} // Close the menu
        anchorOrigin={{
            vertical: 'bottom',
        
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
            '& .MuiMenuItem-root': {
              padding: '4px 16px', // Reduce padding around each menu item
              fontSize: '0.875rem', // Optionally adjust font size
            }
          }}
      >
        {selectedRowId === item.id && (
          <MenuItem
            onClick={() => {
              handleClose(); // Close the menu
              openPaymentModal(item); // Open the payment modal
            }}
            className='font-inter' 
       
          >
            Payments
          </MenuItem>
        )}
      </Menu>
      </div>
   
    </div>
  );
};

export default DropdownMenu;
